var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"bar",staticStyle:{"width":"280px","height":"280px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }